/** Tracks executions the user explicitly stopped so terminal failure toasts are suppressed. */

const userStoppedExecutionIds = new Set<string>()

export function markExecutionStoppedByUser(executionId: string): void {
  userStoppedExecutionIds.add(executionId)
}

/** Returns true once per stop intent (clears the mark). */
export function consumeExecutionStoppedByUser(executionId: string): boolean {
  if (!userStoppedExecutionIds.has(executionId)) return false
  userStoppedExecutionIds.delete(executionId)
  return true
}

export const WORKFLOW_STOPPED_TOAST_MESSAGE = 'Response stopped.'
